export default __webpack_public_path__ + "static/media/flag-south-sudan.fbbc9b88.svg";